module.exports = __webpack_public_path__ + "static/img/12bg_9.8e6152e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_9.png
// module id = 639
// module chunks = 1